import customAxios           from '../../customAxios';
import { LOCATION_CITY } from '../../routes';
import { locationNamespace } from '../../../types/location.namespace';

async function createCity(props: locationNamespace.city.create) {
  try {
    return (await customAxios.post(LOCATION_CITY, props)).data;
  } catch (error: any) {
    console.error({LOCATION_CITY: error});
  }
}

export default createCity;
